import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

// Updated cancellation policy data based on provided terms
const defaultCancellationPolicy = [
  { period: "30+ days before departure", fees: "50% of trip cost" },
  { period: "15-30 days before departure", fees: "75% of trip cost" },
  { period: "0-15 days before departure", fees: "100% of trip cost" }
];

const ItineraryCancellation = ({ cancellationRef }) => (
  <div ref={cancellationRef} id="cancellation-section" className="cancellation-policy-section">
    <h2><FaExclamationTriangle /> Cancellation Policy</h2>
    <div className="cancellation-policy-table-wrapper">
      <table className="cancellation-policy-table">
        <thead>
          <tr>
            <th>Cancellation Period</th>
            <th>Cancellation Fees</th>
          </tr>
        </thead>
        <tbody>
          {defaultCancellationPolicy.map((row, idx) => (
            <tr key={idx}>
              <td>{row.period}</td>
              <td>{row.fees}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className="cancellation-policy-extra-block">
      <div className="cancellation-policy-extra-title">Important Cancellation & Refund Notes:</div>
      <ul className="cancellation-policy-extra-list">
        <li>
          In case of cancellation of group from organizer side due to any unavoidable circumstances, we will try to transfer the booking in other departure (if client deny opting for transfer of booking to other group then there will be no refund)
        </li>
        <li>
          <strong>
            In case of cancellation from client side after the registration at any point of time, then in that case there will be no refund or adjustment of booking amount.
          </strong>
        </li>
        <li>
          <strong>
            Advance amount is non refundable or non transferable to any other members.
          </strong>
        </li>
        <li>
          In the case of unforeseen weather conditions or government restrictions, certain activities may be canceled and in such cases, the operator will try his best to provide an alternate feasible activity. However, no refund will be provided for the same.
        </li>
        <li>
          No Refund. In case of the change of the departure date
        </li>
        <li>
          SWAYOURWAY reserve the right to change the booking date of client in case of customer request before 60 days prior. NO REFUND ON UNUTILIZED SERVICES OF THE PACKAGES, (IF ANY)
        </li>
      </ul>
    </div>
  </div>
);

export default ItineraryCancellation;
